const { createRouter, createWebHashHistory } = require("vue-router");
import Home from "./views/Home";
import Introduction from "./views/Introduction";
import Business from "./views/Business";
import ContactUs from "./views/ContactUs";
import Product from './views/Product';
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: "/", component: Home },
    { path: "/introduction", component: Introduction },
    { path: "/business", component: Business },
    { path: "/contactus", component: ContactUs },
    { path: "/product", component: Product },
  ],
});

export default router;
